import { throttle } from 'throttle-debounce';

// add "sticky" class to el when it reaches the top of the screen 
// removes the "sticky" class when the next sibling element is greater than the threshold (100px) for now.
export const makeSticky = (el, nextEl) => {
  document.addEventListener('scroll', throttle(200, function() {
    const elRect = el.getBoundingClientRect();
    const nextElRect = nextEl.getBoundingClientRect();
    if (elRect.top < 0) {
      el.classList.add('sticky');
    }
    if (elRect.top === 0 && nextElRect.top > 100) {
      el.classList.remove('sticky');
    }
  }));
}

export const isDesktop = () => {
  const vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  return (vw >= 1040);
}

export const onWindowResize = (cb) => {
  window.addEventListener('resize', throttle(200, cb));
}